export default __webpack_public_path__ + "static/media/icon-insights-social.8bfbd869.svg";